import {createSelector} from "reselect";


const RenterInsuranceState = (state) => state.renterInsurance

export const getFinalRenterData = createSelector(RenterInsuranceState,state => state.finalData)

